import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

const authClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": process.env.REACT_APP_FRONTEND_API_KEY || "dev_secret_key_12345"
  },
  timeout: 10000,
});

export async function login(username, password) {
  try {
    // OAuth2 requires x-www-form-urlencoded
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);

    const response = await authClient.post("/api/v1/auth/login", formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
    return { data: response.data, error: null };
  } catch (err) {
    return { data: null, error: buildErrorMessage(err) };
  }
}

export async function register(username, password) {
  try {
    const response = await authClient.post("/api/v1/auth/register", {
      username,
      password
    });
    return { data: response.data, error: null };
  } catch (err) {
    return { data: null, error: buildErrorMessage(err) };
  }
}

function buildErrorMessage(err) {
  if (!err.response) {
    return "Backend'e bağlanılamadı.";
  }
  const { status, data } = err.response;
  if (status === 401) return "Kullanıcı adı veya şifre hatalı.";
  if (status === 400) return data?.detail || "Geçersiz istek.";
  if (status === 429) return "Çok fazla deneme yaptınız. Lütfen biraz bekleyin.";
  return data?.detail || `Beklenmedik hata (HTTP ${status}).`;
}
